import { FunctionComponent, h } from 'preact';
import { Icon } from 'components/icon/icon';
import { useTranslation } from 'hooks';
import { api } from 'api';
import { useCallback, useContext, useEffect } from 'preact/hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { openUrl } from '@uw/utils';
import { headerStore } from 'global/header.store';
import { INITIAL_PAGE_STATE } from 'constants/constants';
import { getTempAuthCode } from 'helpers/services/sso';
import './lst-upgrade.scss';
import { getDashboardRedirectUrl } from './utils/get-dashboard-url';

export const LstUpgrade: FunctionComponent = () => {
  const { translate } = useTranslation();
  const { tunings } = useContext(ApplicationContext);

  useEffect(() => {
    headerStore.backState.next(INITIAL_PAGE_STATE);
  }, []);

  const redirectToDashboard = useCallback(
    async (e: Event) => {
      e.preventDefault();

      try {
        const baseUrl = '__BASE_MANAGE__';
        const tempCode = await getTempAuthCode(api);
        const redirectPath = `/widget/my-sites/p/1/site-details/addons?site=${tunings.site_name}#lst-addon`;

        const redirectUrl = getDashboardRedirectUrl(baseUrl, tempCode, redirectPath);

        openUrl(redirectUrl);
      } catch (error) {
        console.error(error);
      }
    },
    [api, tunings.site_name],
  );

  return (
    <div className="uwaw-lst-upgrade-card">
      <div className="uwaw-lst-upgrade-card__inner">
        <div className="uwaw-lst-upgrade-card__header">
          <div>
            <h2 className="uwaw-lst-upgrade-card__title">
              {translate('widget.lst_upgrade.title')}
            </h2>
            <p className="uwaw-lst-upgrade-card__subtitle">
              {translate('widget.lst_upgrade.description')}
            </p>
          </div>
          <div className="uwaw-lst-upgrade-card__icon">
            <Icon type="lst-flags" />
          </div>
        </div>

        <div className="uwaw-lst-upgrade-card__footer">
          <a
            href="#"
            className="uwaw-lst-upgrade-card__button uwaw-btn__primary"
            onClick={redirectToDashboard}
            role="link"
          >
            {translate('widget.upgrade.button')}
          </a>
        </div>
      </div>
    </div>
  );
};
